




import Vue from 'vue';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  beforeMount() {
    Vue.$router.replace('/_admin/dashboard');
  },
});
